
























































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import Miembro from "@/models/miembro/miembro.model";
import GenericAdd from "@/core/Generics/GenericAdd";
import Helpers from "@/helpers/helper";
import moment from "moment";
import { AxiosResponse } from "axios";
import Persona from "../../models/persona/persona.model";
import { Utils } from "../../core/Utils";
import NameValue from "@/models/nameValue.model";
import DatePickerComponent from "@/components/base-datePicker/base-date-picker.vue";

@Component({
  components: {
    DatePickerComponent
  }
})
export default class MiembroEdit extends GenericAdd<Miembro> {
  @Prop() public controller!: string;
  @Prop() public action!: string;
  @Prop() public codigoHogar!: string;
  @Prop() public hogarId!: number;
  @Prop() public title!: string;
  @Prop() public value!: Miembro;

  model!: Miembro;
  constructor() {
    super();
    this.exitOnSave = false;
    this.model = this.map(this.value);
    this.model.hogarId = this.hogarId;
    this.model.codigoHogar = this.codigoHogar;
    let fecha = (this.model.persona as Persona).fechaNacimiento;
    if (fecha)
      (this.model.persona as Persona).fechaNacimiento = new Date(
        fecha.toString()
      );
  }
  get isMobile() {
    return this.$store.state.isMobile;
  }
  get edadvalue() {
    let fecha = (this.value.persona as Persona).fechaNacimiento;
    return fecha ? Helpers.Filters.EdadText(fecha.toString()) : String();
  }
  get edad() {
    let fecha = (this.model.persona as Persona).fechaNacimiento;
    return fecha ? Helpers.Filters.Edad(fecha.toString()) : 0;
  }
  get edadText() {
    let fecha = (this.model.persona as Persona).fechaNacimiento;
    return fecha ? Helpers.Filters.EdadText(fecha.toString()) : 0;
  }

  public async isValid() {
    try {
      let isValid = await this.$validator.validateAll();
      if (isValid) return true;

      throw this.$validator.errors.items.map(e => e.msg);
    } catch (errors) {
      this.operationFailedErrors(errors);
      return false;
    }
  }
  @Watch("model", { deep: true, immediate: true })
  onModelChange(value: Miembro) {
    this.$emit("input", value);
  }

  @Watch("value", { deep: true })
  onValueChange(value: Miembro) {
    this.model = this.map(this.value);
    let fecha = (this.model.persona as Persona).fechaNacimiento;
    if (fecha)
      (this.model.persona as Persona).fechaNacimiento = new Date(
        fecha.toString()
      );
  }

  onSelectParentesco(value: NameValue) {
    this.model.parentescoNombre = value ? value.descripcion : String();
  }
}
